export default {
  imgs: [
    {
      name: "乐园背景",
      src: require("@img/village/bg.jpg"),
    },
    {
      name: "乐园入口",
      src: require("@img/village/entry.png"),
    },
    {
      name: "map_1地图",
      src: require("@img/village/floor.png"),
    },
    // {
    //   name: "乐园敬请期待",
    //   src: require("@img/village/house-future.png"),
    // },
    {
      name: "消消乐入口",
      src: require("@img/village/house-game_xiaoxiaole.png"),
    },
    {
      name: "合成大西瓜入口",
      src: require("@img/village/house-game_xigua.png"),
    },
    {
      name: "排行榜入口",
      src: require("@img/village/house-range.png"),
    },
    {
      name: "商店入口",
      src: require("@img/village/house-store.png"),
    },
    {
      name: "羊了个羊入口",
      src: require("@img/village/house-monster.png"),
    },
    {
      name: "入口名字背景",
      src: require("@img/village/house-name.png"),
    },
    // {
    //   name: "排行榜背景",
    //   src: require("@img/village/rank-bg.png"),
    // },
    {
      name: "排行榜行背景_1",
      src: require("@img/village/row-bg_1.png"),
    },
    {
      name: "排行榜行背景_2",
      src: require("@img/village/row-bg_2.png"),
    },
    {
      name: "排行榜行背景_3",
      src: require("@img/village/row-bg_3.png"),
    },
    {
      name: "兑换商店_商品背景",
      src: require("@img/village/store-goods_bg.png"),
    },
    {
      name: "兑换商店_商品上层图片",
      src: require("@img/village/store-goods-pic-cover.png"),
    },
    {
      name: "兑换商店_无库存提示背景",
      src: require("@img/village/store-goods_limited_bg.png"),
    },
    {
      name: "兑换商店_确认兑换弹窗物品背景",
      src: require("@img/village/store-goods_commit.png"),
    },
    {
      name: "对战模式选择_单人",
      src: require("@img/village/game-modal_single.png"),
    },
    {
      name: "对战模式选择_对战",
      src: require("@img/village/game-modal_battle.png"),
    },
    {
      name: "vs",
      src: require("@img/village/result-vs.png"),
    },
    {
      name: "结果弹窗散光背景",
      src: require("@img/village/result-top_bg.png"),
    },
    {
      name: "结果弹窗底部背景",
      src: require("@img/village/result-bottom_bg.png"),
    },
    {
      name: "胜利文字背景",
      src: require("@img/village/result-winner-bg.png"),
    },
    {
      name: "乐园等级图标-novice",
      src: require("@img/village/levelIcon/0_novice.png"),
    },
    {
      name: "乐园等级图标-normal",
      src: require("@img/village/levelIcon/1_normal.png"),
    },
    {
      name: "乐园等级图标-good",
      src: require("@img/village/levelIcon/2_good.png"),
    },
    {
      name: "乐园等级图标-excellent",
      src: require("@img/village/levelIcon/3_excellent.png"),
    },
    {
      name: "乐园等级图标-wonderful",
      src: require("@img/village/levelIcon/4_wonderful.png"),
    },
    {
      name: "乐园等级图标-professional",
      src: require("@img/village/levelIcon/5_professional.png"),
    },
    {
      name: "乐园等级图标-Gold",
      src: require("@img/village/levelIcon/6_Gold.png"),
    },
    {
      name: "乐园等级图标-Platinum",
      src: require("@img/village/levelIcon/7_Platinum.png"),
    },
    {
      name: "乐园等级图标-Diamond",
      src: require("@img/village/levelIcon/8_Diamond.png"),
    },
    {
      name: "乐园等级图标-Master",
      src: require("@img/village/levelIcon/9_Master.png"),
    },
    {
      name: "乐园等级图标-King",
      src: require("@img/village/levelIcon/10_King.png"),
    },
    {
      name: "周奖励弹窗图片",
      src: require("@img/village/box.png"),
    },
  ],
};
